
import React, { Component } from 'react';
import { render } from 'react-dom';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';

import ImportCategoryParcel from './ImportCategoryParcel';

let resolve;

class DialogImportCategoryParcel extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogImportCategoryParcel />, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            onImport: null,
            categoryParcel: null,
            categoryParcelItems: null
        };
    }

    checkValues() {
        let warnings = [];
        return (warnings.length === 0);
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(null);
    }

    handleConfirm = () => {
        if (this.checkValues()) {
            this.setState({hidden: true});
            resolve(true);
        }
    }

    handleImport = (categoryItems, parc, keepCategoryItemNames, importMode) => {
        if (this.state.onImport) {
            this.state.onImport(categoryItems, parc, keepCategoryItemNames, importMode);
        }
        this.setState({hidden: true});
        resolve(true);
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={600}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Import do aktuální kategorie parcel"
                }}
                modalProps={{
                    isBlocking: false
                }}
                >
                    <ImportCategoryParcel
                        categoryParcel={this.state.categoryParcel}
                        categoryParcelItems={this.state.categoryParcelItems}
                        onImport={this.handleImport}
                    />
                <DialogFooter>
                    <DefaultButton onClick={this.handleCancel} text="Zavřít" />
                </DialogFooter>
            </Dialog>
        );
    }

    show(categoryParcel, categoryParcelItems, onImport) {
        this.setState({
            hidden: false,
            categoryParcel: categoryParcel,
            categoryParcelItems: categoryParcelItems,
            onImport,
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogImportCategoryParcel.create();
